import React from 'react';
import '../../styles/shared/LoadingSpinner.css';
import { MEDIA_URL } from '../../config/constants';

const LoadingSpinner = ({ text = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="loading-logo-wrapper">
        <img
          src={`${MEDIA_URL}/images/sun_catchers_logo.png`}
          alt="Sun Catchers"
          className="loading-logo"
        />
      </div>
      <p className="loading-text">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
